export default __webpack_public_path__ + "static/media/html.d2c13725.svg";